import React from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import './Restorative.css';

const Restorative = () => {
    const pricing = [
        { type: "Diastema Closure per side", price: "₱2,000" },
        { type: "Temporary Dressing", price: "₱800 - ₱2,000" },
        { type: "Composite Filling (per surface)", price: "₱1,000" },
        { type: "Inlay | Onlay (Composite)", price: "₱7,000 - ₱8,000" },
    
    ];

    return (
        <>
        <Header />
        <div className="restorative-container">
        
            <div className="restorative-content">
                <h1>RESTORATIVE</h1>
                <p>
                restorative dentistry is to repair damaged teeth or replace missing ones.
                 The goal is to save teeth and to provide teeth that look, feel, and work like natural teeth. 
                 The restored teeth also help keep your other teeth spaced correctly for a normal bite.
                </p>
                <h2>Pricing</h2>
                <table className="restorative-table">
                        <thead>
                            <tr>
                                <th>Type of Surgery</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pricing.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.type}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ContactUsFooter />
        </>
    );
};


export default Restorative;